/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index portal-root to autogenerate all the components and extensions
 * Used by "preparePortalRoots"
 */

import PortalRoot from './portal-root/PortalRoot'
export * from './portal-root/PortalRoot'
export default PortalRoot
